import { render, staticRenderFns } from "./wechatMallManage.vue?vue&type=template&id=dae30c08&scoped=true"
import script from "./wechatMallManage.vue?vue&type=script&lang=js"
export * from "./wechatMallManage.vue?vue&type=script&lang=js"
import style0 from "./wechatMallManage.vue?vue&type=style&index=0&id=dae30c08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae30c08",
  null
  
)

export default component.exports